import * as React from 'react'
import { CSSProperties, useState } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAuthenticatedUser } from '../../store/auth/authSlice'
import styled from 'styled-components'

const CustomDropDownItemDiv = styled.div`
  padding: 0rem 0.25rem;
  &:hover {
    border-radius: 0.25rem;
    background: var(--zocks-primary-light);
  }
  &.disabled {
    li {
      color: var(--gray-color-gray-500, #adb5bd);
    }
  }
`

export const CustomDropdownItem = React.forwardRef<
  HTMLDivElement,
  {
    children?: React.ReactNode
    style?: CSSProperties
    className?: string
    'aria-labelledby'?: string
    onClick?: () => void
  }
>(({ children, style, className, 'aria-labelledby': labeledBy, onClick }, ref) => {
  return (
    <CustomDropDownItemDiv
      onClick={onClick}
      role='button'
      ref={ref}
      style={style}
      className={`${className ? className : ''}`}
      aria-labelledby={labeledBy}
      dir='ltr'
    >
      <li className='paragraph-small zocks-text-gray-900'>{children}</li>
    </CustomDropDownItemDiv>
  )
})
